import { authTokenVault } from "@/shared/api/authTokenVault";
import { activeOrganizationVault } from "@/shared/api/activeOrganizationVault";
import { refreshResponseSchema } from "@/shared/api/browserAuthSchemas";

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL ?? "")
  .trim()
  .replace(/\/+$/, "");

let browserRefreshPromise: Promise<string | null> | null = null;

export function refreshBrowserAccessToken() {
  browserRefreshPromise ??= fetch(`${apiBaseUrl}/v1/auth/refresh`, {
    credentials: "include",
    method: "POST",
  })
    .then(async (response) => {
      if (!response.ok || response.status === 204) {
        authTokenVault.clear();
        activeOrganizationVault.clear();
        return null;
      }
      const parsed = refreshResponseSchema.safeParse(await response.json());
      if (!parsed.success) {
        authTokenVault.clear();
        activeOrganizationVault.clear();
        return null;
      }
      authTokenVault.set(parsed.data.accessToken);
      return parsed.data.accessToken;
    })
    .catch(() => {
      authTokenVault.clear();
      activeOrganizationVault.clear();
      return null;
    })
    .finally(() => {
      browserRefreshPromise = null;
    });
  return browserRefreshPromise;
}

export async function browserApiFetch(path: string, init: RequestInit = {}) {
  const execute = () => {
    const headers = new Headers(init.headers);
    const accessToken = authTokenVault.get();
    if (accessToken) headers.set("Authorization", `Bearer ${accessToken}`);
    const activeOrganizationId = activeOrganizationVault.get();
    if (accessToken && activeOrganizationId) {
      headers.set("X-Merry-Organization-ID", activeOrganizationId);
    }
    return fetch(`${apiBaseUrl}${path}`, {
      ...init,
      credentials: "include",
      headers,
    });
  };

  let response = await execute();
  if (response.status === 401 && (await refreshBrowserAccessToken())) {
    response = await execute();
  }
  return response;
}
